<template>
    <div>
        <SoliForm
            ref="form"
            :textSubtitle="`To: ${emails.join(', ')}`"
            :retainFocus="false"
            persistent
            :loadingProp="loading"
            large
            title="Compose Email"
            text="Send it!"
            icon="email"
            limitSubtitle
            @submit="submit()"
            @reset="reset()"
        >
            <template #body>
                <!--<v-switch
                    v-if="can('Email as studio')"
                    v-model="form.bcc"
                    label="BCC Recipients"
                    dense
                    hide-details="auto"
                    class="pb-4 pt-0 mt-0"
                />-->
                <div class="flex flex-col gap-2 mb-3">
                    <v-select
                        v-if="can('Email as studio') && sendAsStudio"
                        label="From"
                        :items="[user.email, user.selected_location.email]"
                        v-model="emailFrom"
                        dense
                        outlined
                        hide-details
                        :errors="errors.emailFrom"
                        :rules="rules.select"
                    />
                    <SoliStudents
                        v-if="can('Email as studio')"
                        v-model="form.cc"
                        :label="form.bcc ? 'BCC:' : 'CC:'"
                        :icon="false"
                        dense
                        autocomplete
                        multiple
                        hasEmail
                        chips
                        deletableChips
                        smallChips
                        closeOnClick
                        onDemand
                        hideDetails="auto"
                        single-line
                        includeTeachers
                    />
                    <SoliText
                        v-if="!subject"
                        v-model="form.subject"
                        label="Subject"
                        :rules="rules.input"
                        :errors="errors?.subject"
                        validateOnBlur
                        hide-details="auto"
                    />
                </div>
                <div class="px-1 mb-3" v-if="greeting && !form.bcc">
                    <small class="soli-grey">Hey [first_name]</small>
                </div>
                <TinyEditor
                    v-if="tinyMCE"
                    v-model="form.message"
                    :errors="errors?.message"
                ></TinyEditor>
                <v-textarea
                    v-else
                    v-model="form.message"
                    :error-messages="errors?.message"
                    :rules="rules.input"
                    outlined
                    placeholder="What's on your mind?"
                    :height="300"
                />
                <div class="pl-1 pb-3" v-if="signature">
                    <small class="soli-grey"
                        >Thanks! <br />
                        {{ user.name }}
                    </small>
                </div>
            </template>
        </SoliForm>
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment";
import TinyEditor from "./../TinyEditor.vue";
import SoliForm from "./../Base/SoliForm.vue";

export default {
    name: "ComposeEmail",
    components: { TinyEditor },
    mixins: [globalMoment],
    props: {
        errors: {},
        greeting: {
            type: Boolean,
            default: false,
        },
        signature: {
            type: Boolean,
            default: false,
        },
        sendAsStudio: {
            type: Boolean,
            default: false,
        },
        emails: {
            type: Array,
            default: () => [],
        },
        tinyMCE: {
            type: Boolean,
            default: false,
        },
        subject: {
            type: String,
            default: null,
        },
        user: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                message: "",
                subject: "",
                emails: this.emails,
                signature: Number(this.signature),
                greeting: Number(this.greeting),
                sendAsStudio: 0,
                bcc: this.emails.length > 1,
                cc: [],
            }),
            rules: SoliForm.formRules,
            emailFrom: this.user.email,
            loading: false,
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.form
                .transform((data) => ({
                    ...data,
                    cc: data.cc.map((item) => item.email),
                }))
                .post(route("customMessage"), {
                    onSuccess: () => {
                        this.$emit("success");
                        this.loading = false;
                    },
                    onError: (errors) => {
                        console.log(errors);
                        this.loading = false;
                    },
                });
        },
        reset() {
            this.$emit("reset");
        },
    },
    watch: {
        form: {
            handler(val) {
                this.form.bcc = val.emails.length > 1;
            },
            deep: true,
        },
        emailFrom(val) {
            this.form.sendAsStudio = val == this.user.email ? 0 : 1;
        },
    },
};
</script>
